import script from "./Textarea.vue?vue&type=script&setup=true&lang=js"
export * from "./Textarea.vue?vue&type=script&setup=true&lang=js"

import "./Textarea.vue?vue&type=style&index=0&id=cf6d9b34&lang=scss"

const __exports__ = script;

export default __exports__